<!-- 查看机构监测仪床位绑定情况 -->
<template>
    <div class="main" style="width: 1180px;">
        <a-card>
            <div class="btns">
                <div v-if="searchValIsHide" class="leftSearch">
                    <div>
                        <a-input-search
                            placeholder="请输入SN码"
                            style="width: 240px"
                            v-model="searchVal"
                            @search="onSearch"
                        />
                    </div>
                </div>
                <div v-else>
                    <span
                        >关于“{{ searchVal }}”共搜索到<span
                            style="color: #1890ff"
                        >
                            {{ total }} </span
                        >条结果</span
                    >
                    <span
                        @click="backBtn"
                        style="
                            color: #1890ff;
                            cursor: pointer;
                            margin-left: 20px;
                        "
                        >返回</span
                    >
                </div>
            </div>
            <div v-if="tableData.length != 0">
                <a-table
                    :columns="columns"
                    :data-source="tableData"
                    bordered
                    :pagination="false"
                    rowKey="userId"
                >
                    <template slot="beds" slot-scope="scope">
                        <span
                            >{{ scope.buildingName }}-{{ scope.floorName }}-{{
                                scope.roomName
                            }}-{{ scope.bedName }}</span
                        >
                    </template>
                </a-table>
            </div>
            <a-empty v-else />
        </a-card>
        <a-pagination
            :pageSize="pageSize"
            v-model="pageNum"
            :total="total"
            @change="pageChange"
            show-less-items
            style="text-align: center; margin-top: 10px"
            :hideOnSinglePage="true"
        />
    </div>
</template>

<script>
const columns = [
    {
        title: "监测仪SN码",
        dataIndex: "snCode",
        align: "center",
        width: "50%",
    },
    {
        title: "监测床位",
        align: "center",
        width: "50%",
        scopedSlots: { customRender: "beds" },
    },
];
export default {
    data() {
        return {
            tableData: [], // 表格数据
            columns,
            searchValIsHide: true,
            searchVal: "",
            total: 0,
            pageNum: 1,
            pageSize: 10,
        };
    },
    computed: {},
    mounted() {
        this.getTableData();
    },
    methods: {
        // 获取表格信息
        getTableData(firstSearch) {
            this.pageNum = firstSearch?1:this.pageNum;
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                snCode: this.searchVal,
            };
            
            this.$get(
                "/api/radar/page4tenant/" + this.$route.query.id,
                param,
                (res) => {
                    if (res.code == 0) {
                        if (res.data.radarShowVOIPage.records) {
                            this.tableData = res.data.radarShowVOIPage.records;
                            this.total = res.data.radarShowVOIPage.total;
                        } else {
                            this.tableData = [];
                            this.total = 0;
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    console.log(err);
                    // this.$message.error("服务端发生异常");
                }
            );
        },
        // 分页
        pageChange(e) {
            console.log(e);
            this.pageNum = e;
            this.getTableData();
        },
        // 搜索
        onSearch() {
            this.getTableData(1);
            this.searchValIsHide = false;
        },
        // 搜索返回
        backBtn() {
            this.searchVal = "";
            this.searchValIsHide = true;
            this.getTableData();
        },
    },
};
</script>

<style lang='scss' scoped>
.main::v-deep {
    padding-top: 0 !important;
    .ant-card {
        margin-top: 10px;
        padding: 15px 20px;
        border-radius: 8px;
        .ant-card-body {
            padding: 0;
        }
    }
    .btns {
        .leftSearch {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        margin-bottom: 10px;
        p {
            margin-bottom: 0;
            span {
                color: #1890ff;
            }
        }
    }
    .ant-table-thead > tr > th {
        background: #f0f0f0;
    }
    .ant-table-tbody {
        min-height: 604px;
        .ant-table-row:nth-child(even) {
            background: #fafafa;
        }
    }
    .ant-table-row td:nth-child(5) {
        padding-bottom: 6px;
    }
    .ant-table-content {
        min-height: 604px;
    }
    .ant-table-thead
        > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td,
    .ant-table-tbody
        > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td,
    .ant-table-thead
        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td,
    .ant-table-tbody
        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
        > td {
        background: none;
    }
    .operation {
        display: flex;
        align-items: center;
        justify-content: center;
        .tableIcon {
            color: #1890ff;
            font-size: 20px;
            cursor: pointer;
        }
        .tableImg {
            margin-left: 10px;
            cursor: pointer;
            vertical-align: baseline;
        }
    }
}
</style>